export enum DisputeEventTypes {
    DisputeCreated = 1,
    DisputeRoutedToUser = 2,
    DisputeRoutedToVendor = 3,
    DisputeEscalated=4,
    DisputeApproved=5,
    DisputeDenied=6,
    DisputeDeleted=7,
    NoteAdded=8,
    DisputeRoutedBack=9,
    DocumentAdded=10,
    Reopened=11,
    DisputePaid=12,
    DisputeCompleted=13,
}